import { Schema, arrayOf } from 'normalizr'

const archivedStudy = new Schema('archivedStudies')
const boxTranscriptProduct = new Schema('boxTranscriptProducts')
const branding = new Schema('brandings')
const clip = new Schema('clips')
const company = new Schema('companies')
const country = new Schema('countries')
const emailDomain = new Schema('emailDomains')
const highlight = new Schema('highlights')
const metaTag = new Schema('metaTags')
const project = new Schema('projects')
const report = new Schema('reports')
const response = new Schema('responses')
const role = new Schema('roles')
const search = new Schema('searches')
const tag = new Schema('tags')
const user = new Schema('users')
const unarchiveStudyRequest = new Schema('unarchiveStudyRequests')
const workspace = new Schema('workspaces')

clip.define({
  workspaces: arrayOf(workspace)
})

highlight.define({
  metaTags: arrayOf(metaTag),
  owner: user,
  tags: arrayOf(tag),
  workspaces: arrayOf(workspace)
})

project.define({
  countries: arrayOf(country),
  metaTags: arrayOf(metaTag),
  owner: user,
  tags: arrayOf(tag),
  workspaces: arrayOf(workspace)
})

report.define({
  tags: arrayOf(tag),
  workspaces: arrayOf(workspace)
})

response.define({
  workspaces: arrayOf(workspace)
})

workspace.define({
  owner: user
})

export const ARCHIVED_STUDY = archivedStudy
export const ARCHIVED_STUDY_COLLECTION = arrayOf(archivedStudy)
export const BOX_TRANSCRIPT_PRODUCT = boxTranscriptProduct
export const BOX_TRANSCRIPT_PRODUCT_COLLECTION = arrayOf(boxTranscriptProduct)
export const BRANDING = branding
export const CLIP = clip
export const COMPANY = company
export const COMPANY_COLLECTION = arrayOf(company)
export const COUNTRY = country
export const COUNTRY_COLLECTION = arrayOf(country)
export const EMAIL_DOMAIN = emailDomain
export const EMAIL_DOMAIN_COLLECTION = arrayOf(emailDomain)
export const HIGHLIGHT = highlight
export const HIGHLIGHT_COLLECTION = arrayOf(highlight)
export const META_TAG = metaTag
export const META_TAG_COLLECTION = arrayOf(metaTag)
export const NONE = 'NONE'
export const PROJECT = project
export const PROJECT_COLLECTION = arrayOf(project)
export const REPORT = report
export const REPORT_COLLECTION = arrayOf(report)
export const RESPONSE = response
export const ROLE = role
export const ROLE_COLLECTION = arrayOf(role)
export const SEARCH = search
export const SEARCH_COLLECTION = arrayOf(search)
export const TAG = tag
export const TAG_COLLECTION = arrayOf(tag)
export const USER = user
export const USER_COLLECTION = arrayOf(user)
export const UNARCHIVE_STUDY_REQUEST = unarchiveStudyRequest
export const WORKSPACE = workspace
export const WORKSPACE_COLLECTION = arrayOf(workspace)



// WEBPACK FOOTER //
// ../src/schemas/index.js